__turbopack_context__.v({
  "lds-ring": "Loader-module-scss-module__de_I2q__lds-ring",
  "loader": "Loader-module-scss-module__de_I2q__loader",
  "loaderStroke2": "Loader-module-scss-module__de_I2q__loaderStroke2",
  "loaderStroke3": "Loader-module-scss-module__de_I2q__loaderStroke3",
  "white": "Loader-module-scss-module__de_I2q__white",
});
